export enum FacultyCarouselItemTypes {
  FacultyProfileDetail = "facultyProfileDetail",
  StudentProfileDetail = "studentProfileDetail",
  ContributorProfileDetail = "contributorProfileDetail",
  Extended = "facultyProfileExtended",
}
